@if (!webReportMobileItems) {
  <ion-row class="sis-center">
    <ion-col>
      <ion-spinner></ion-spinner>
    </ion-col>
  </ion-row>
}

@if (!webReportMobileItems?.length) {
  <ion-row class="sis-center">
    <ion-col>
      <span style="color: white"
        >{{ 'webreport.term.no' | translate }} {{ titleTranslationString | translate }}
        {{ 'webreport.term.available' | translate }}</span
        >
      </ion-col>
    </ion-row>
  }

  @for (item of webReportMobileItems; track trackByTenantAlias($index, item)) {
    <sis-webreport-mobile-tenant
      [tenantAlias]="item.tenantAlias"
      [items]="item.items"
      [config]="config"
      [mobileStyleTenant]="mobileStyleTenant"
      [longestLabelLength]="item.longestLabelLength"
    ></sis-webreport-mobile-tenant>
  }
